__turbopack_context__.v({
  "ShapeP": "Shapes-module-scss-module__0Q0uMq__ShapeP",
  "ShapeSquare": "Shapes-module-scss-module__0Q0uMq__ShapeSquare",
  "Shapes": "Shapes-module-scss-module__0Q0uMq__Shapes",
});
